import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Shippings } from '@pages/checkout-app/types';

@Component({
  selector: 'fee-per-cart-value',
  templateUrl: './fee-per-cart-value.component.html',
  styleUrls: ['./fee-per-cart-value.component.scss'],
  standalone: false,
})
export class FeePerCartValueComponent implements OnInit, OnChanges {
  @Input() formGroup: UntypedFormGroup;
  @Input() loadedValues: Shippings;
  fieldSetName = 'feePerCartValue';

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {}

  getFromGroup(formGroupName: string): UntypedFormGroup {
    return this.formGroup.get(formGroupName) as UntypedFormGroup;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.loadedValues?.currentValue) {
      const feePerCartValue = changes.loadedValues.currentValue[this.fieldSetName];
      if (feePerCartValue) {
        const feePerCartValueFormGroup = this.getFromGroup(this.fieldSetName);
        feePerCartValueFormGroup.controls['enabled'].setValue(feePerCartValue.enabled ?? false);
        feePerCartValueFormGroup.controls['amount'].setValue(+(feePerCartValue.amount ?? 0.1));
      }
    }
  }
}
